import { useDeviceType, TDeviceType } from '@cian/ui-kit';
import * as React from 'react';

interface IDeviceType {
  children(deviceType: TDeviceType): React.ReactNode;
}

export const DeviceType: React.FC<IDeviceType> = ({ children }) => <>{children(useDeviceType())}</>;

DeviceType.displayName = 'ResponsiveDeviceType';
